/* eslint-disable no-unused-vars */
/* eslint-disable spaced-comment */
/* eslint-disable no-param-reassign */
import logs from "../Logs/index";
import { merge } from "lodash";
import axios from "axios";

import { API_NAMES } from "./constants";

export const get = (
  webApiSuffix,
  extendedOptions = { isErrorHandlingNeeded: true },
  webapiName = "MAIN"
) => call(webapiName, webApiSuffix, "GET", extendedOptions);

export const post = (webApiSuffix, extendedOptions = {}, webapiName = "MAIN") =>
  call(webapiName, webApiSuffix, "POST", extendedOptions);

export const put = (webApiSuffix, extendedOptions = {}, webapiName = "MAIN") =>
  call(webapiName, webApiSuffix, "PUT", extendedOptions);

export const del = (webApiSuffix, extendedOptions = {}, webapiName = "MAIN") =>
  call(webapiName, webApiSuffix, "DELETE", extendedOptions);

export const patch = (
  webApiSuffix,
  extendedOptions = {},
  webapiName = "MAIN"
) => call(webapiName, webApiSuffix, "PATCH", extendedOptions);

const call = (webapiName, webApiSuffix, method, extendedOptions) =>
  new Promise((resolve, reject) => {
    const url = getWebapiUrl(webapiName) + webApiSuffix;
    const initalHttpData = {
      method, // By default it's POST in case you didnt specify anything
      timeout: 30000,
    };
    const options = merge(initalHttpData, extendedOptions);
    // Fire the request for the prepared options.
    //logs.writeLog(`callApi - url: ${url}`);
    //console.log(`callApi - url: ${url}`);
    return axios(url, options)
    .then(response => {
      if (response?.data === 'JWT in not valid') {

        console.log(`callApi - url: ${url} , response?.data: ${response?.data}`);
        document.location.href = `/CustomerInvestPolicy`;
          //  localStorage.clear();
        
      } else {
        resolve(response);
      }
    })
    .catch(error => {
      if (error.response.status === 401) {

       console.log(`callApi - url: ${url} , 401`);

        document.location.href = `/CustomerInvestPolicy`;
    //    localStorage.clear();
      }
    });
  });

const getWebapiUrl = (name) => {
  if (import.meta.env.MOCK_ONLY === "true") return "";

  const webApiUrlName = `REACT_APP_WEB_API_URL_${name}`;

  let webApiUrl = import.meta.env.VITE_REACT_APP_WEB_API_URL_MAIN; //dev
  if(webApiUrl?.indexOf('http') !== 0){
    webApiUrl = window.location.origin + (webApiUrl || '');
  }

  if (!webApiUrl) {
    // eslint-disable-next-line no-throw-literal
    throw `API url vairable is not defined - ${webApiUrlName}`;
  }

  return webApiUrl;
};

const errorHandler = (error) => {
  const errorCode = (error.response && error.response.status) || 500;
  const errorPath = "/errors";

  if (!window.location.pathname.startsWith(errorPath)) {
    if (errorCode === 401 || errorCode === 403) {
      localStorage.setItem(
        "urlRefferer",
        window.location.pathname + window.location.search
      );
    }
    window.location.href = `${errorPath}/error-${errorCode}`;
  }

  return Promise.reject(error);
};

const doBeforeRequest = (ref) => {
  // ref.headers.common.Authorization = `Bearer ${sessionStorage.getItem(
  //   'token'
  // )}`;
  if (!ref.headers.common) ref.headers.common={};
  
  ref.headers.common["Content-Type"] = "application/json";

  axios.defaults.withCredentials = true;
  // axios.defaults.headers.common.Authorization = `Bearer ${response.token.content}`;
  // axios.interceptors.response.use(undefined, errorHandler);
  // axios.interceptors.response.use(responseToCamelCase, undefined);
  // axios.defaults.params = axios.defaults.params || {};
  return ref;
};

axios.interceptors.request.use(doBeforeRequest, undefined);
